import React from "react";
import { CircularProgress } from "@mui/material";
import { useSignInSignUp } from "../../hooks/useSignInSignUp";
import { SpinnerProps } from "../../1_types/signinTypes";

const Spinner: React.FC<SpinnerProps> = ({ color, size = 25 }) => {
  const { secondaryColor } = useSignInSignUp();
  const newColor = color || secondaryColor;

  return <CircularProgress size={size} style={{ color: newColor }} />;
};

export default Spinner;
